import React, { useEffect, useMemo, useState } from "react";
import { useParams, useHistory } from "react-router-dom";

import { useMastersContext } from "../../../../contexts/masters.context";
import additionalLocationService from "../../../../services/additionalLocationService";
import AdditionalLocationForm from "./forms/AdditionalLocationForm";

function AdditionalLocationAddEdit() {
  const { id } = useParams();
  let history = useHistory();
  const [formData, setFormData] = useState({
    alrC_ID: 0,
    method: "",
    additionalRunChargeNet: "",
    active: false,
  });

  const getData = async () => {
    const result = await additionalLocationService.getOne(id);
    if (id && result) setFormData(result);
  };

  useEffect(() => {
    getData();
  }, []);

  const saveDecoMethod = async (data) => {
    const postData = {
      Id: id,
      Method: data.method,
      RunChargeNet: data.additionalRunChargeNet,
    };

    let result = false;
    if (id) result = await additionalLocationService.update(postData);
    else result = await additionalLocationService.add(postData);

    if (result.success === true) history.goBack();
  };

  const submitForm = (data) => {
    saveDecoMethod(data);
  };

  return (
    <div>
      <h4>{id ? "Edit" : "New"} Additional Location</h4>
      <hr />
      <AdditionalLocationForm formData={formData} submitForm={submitForm} />
    </div>
  );
}

export default AdditionalLocationAddEdit;
